import { debounce } from "lodash"
import * as React from "react"
import { Control, Emitter } from "rete"
import { EventsTypes } from "rete/types/events"

type ExposeToggleProps = {
  getExpose: () => boolean
  setExpose: (value: boolean) => void
}

const EXPOSE_ON_COLOR = "#6ecf8a"
const EXPOSE_OFF_COLOR = "#5a7a62"

const ExposeToggleField = ({ getExpose, setExpose }: ExposeToggleProps) => {
  const [, forceUpdate] = React.useReducer(x => x + 1, 0)
  const exposed = getExpose()

  return (
    <div
      className="expose-toggle-control d-flex justify-content-end"
      style={{ padding: "0.2rem 0.5rem 0.35rem", width: "100%" }}
    >
      <button
        type="button"
        className="expose-toggle-control__btn btn btn-link p-0 border-0 d-flex align-items-center justify-content-center"
        style={{
          color: exposed ? EXPOSE_ON_COLOR : EXPOSE_OFF_COLOR,
          textDecoration: "none",
          flexShrink: 0,
          width: "1.5rem",
          opacity: exposed ? 1 : 0.75,
        }}
        aria-pressed={exposed}
        aria-label={exposed ? "Shown in detail panel" : "Show in detail panel"}
        title={exposed ? "Shown in detail panel" : "Show in detail panel"}
        onClick={e => {
          e.stopPropagation()
          setExpose(!exposed)
          forceUpdate()
        }}
        onPointerDown={e => e.stopPropagation()}
        onDoubleClick={e => e.stopPropagation()}
      >
        <i className={`fas fa-eye${exposed ? "" : "-slash"}`} style={{ fontSize: "1rem" }} />
      </button>
    </div>
  )
}

export class ExposeToggleControl extends Control {
  props: ExposeToggleProps
  component: (props: ExposeToggleProps) => JSX.Element
  type: string

  constructor(emitter: Emitter<EventsTypes> | null, key: string = "expose") {
    super(key)
    this.type = "ExposeToggleControl"

    const notify = debounce(() => emitter?.trigger("process"), 300)
    this.props = {
      getExpose: () => Boolean(this.getData(key)),
      setExpose: value => {
        this.putData(key, value)
        notify()
      },
    }
    this.component = ExposeToggleField
  }
}
